import React, { useEffect } from 'react';
import LoadingScreen from './LoadingScreen';

function ThinkingIndicator({ loadingMessage }) {
  useEffect(() => {
    console.log('🔵 ThinkingIndicator MOUNTED');
    return () => console.log('🔴 ThinkingIndicator UNMOUNTED');
  }, []);

  // Use pre-fetched loading message (stays consistent during loading)
  return <LoadingScreen text={loadingMessage} variant="dots" fullScreen={true} fetchPersonalized={false} />;
}

export default ThinkingIndicator;
